import { render, staticRenderFns } from "./EffectBuilder.vue?vue&type=template&id=23827c43&scoped=true&"
import script from "./EffectBuilder.vue?vue&type=script&lang=js&"
export * from "./EffectBuilder.vue?vue&type=script&lang=js&"
import style0 from "./EffectBuilder.vue?vue&type=style&index=0&id=23827c43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23827c43",
  null
  
)

export default component.exports